// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--3z3x7","warning":"_93444fe79c--warning--2mIaB"};